import CommonActions from './common_actions'

export const { initPagesWithData } = CommonActions
export const { getNodeKey } = CommonActions

const INIT = 'manual_pages_users_views/INIT'
const UPDATE = 'manual_pages_users_views/UPDATE'
const SEARCH = 'manual_pages_users_views/SEARCH'
const UPDATE_NODE_AND_ALL_PARENTS = 'manual_pages_users_views/UPDATE_NODE_AND_ALL_PARENTS'
const BATCH_ACTION_TOGGLE_ID = 'manual_pages_users_views/BATCH_ACTION_TOGGLE_ID'
const BATCH_ACTION_TOGGLE_ALL = 'manual_pages_users_views/BATCH_ACTION_TOGGLE_ALL'
const BATCH_ACTION_LOAD_IDS = 'manual_pages_users_views/BATCH_ACTION_LOAD_IDS'

export const types = {
  INIT,
  UPDATE,
  UPDATE_NODE_AND_ALL_PARENTS,
  SEARCH,
  BATCH_ACTION_TOGGLE_ID,
  BATCH_ACTION_TOGGLE_ALL,
  BATCH_ACTION_LOAD_IDS,
}

export const updateNode = (path, data) => ({ type: UPDATE, path, data })

export const updateNodeAndAllParents = (path, data) => ({ type: UPDATE_NODE_AND_ALL_PARENTS, path, data })

export const fetchTreeData = (data) => {
  return {
    type: INIT,
    request: {
      url: '/manual-pages.json',
      method: 'get',
      filter: data.filter,
      page: data.page,
    },
  }
}

export const filterBy = (value) => ({ type: SEARCH, value })

export const batchActionToggleId = (id) => ({ type: BATCH_ACTION_TOGGLE_ID, id })

export const batchActionToggleAll = () => ({ type: BATCH_ACTION_TOGGLE_ALL })

export const batchActionLoadIds = (ids) => ({ type: BATCH_ACTION_LOAD_IDS, ids })